module.exports = __webpack_public_path__ + "img/21.1c883624.png";